export default __webpack_public_path__ + "static/media/logo.8e8e68a7.svg";